import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { environment } from '../../../environments/environment';

import { NewUser, ResetPassword, ResetPasswordRepeat, ReturnUser, NavbarButton, LoginUser, ResetNeeded, LoginData, ResetPasswordForgotten, RequestChange } from '../interfaces/login';
import { TokenDecoderService } from 'src/app/services/tokenDecoder/token-decoder.service';
import { SnackbarService } from 'src/app/utils/snackbar/snackbar.service';
import { Router } from '@angular/router';
import { UserComplete } from '../interfaces/user';
import { Role, RoleString } from '../../enums/role';
import { StatusEnum } from 'src/app/enums/status';
import { ParametrosService } from './parametros/parametros.service';
import { MessagesService } from './messages/messages.service';


@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private url = environment.apiUrl + '/';
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json'
    }),
    withCredentials: true,
  };
  httpOptionsJson = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }),
    withCredentials: true,
  };
  multipartOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'multipart/form-data'
    })
  };
  constructor(
    private http: HttpClient,
    private tokenDecoderService: TokenDecoderService,
    private snack: SnackbarService,
    private router: Router,
    private parametrosService: ParametrosService,
    private messagesService: MessagesService
  ) { }

  requestChangePassword(email: RequestChange): Observable<ResetPassword> {
    return this.http.post<ResetPassword>(this.url + 'api/usuarios/clave/nueva', email, this.httpOptionsJson);
  }

  getRequest(id: number): Observable<ReturnUser> {
    return this.http.get<ReturnUser>(this.url + `cuenta/requestChangePassword/${id}`, this.httpOptions);
  }

  LoginData(id: number): Observable<ReturnUser> {
    return this.http.get<ReturnUser>(this.url + `cuenta/requestChangePassword/${id}`, this.httpOptions);
  }

  getResetNeeded(): Observable<ResetNeeded> {
    return this.http.get<ResetNeeded>(this.url + `cuenta/resetNeeded/`, this.httpOptions)
  }

  setNewPass(resetPasswordRepeat: ResetPasswordRepeat): Observable<ReturnUser> {
    return this.http.post<ReturnUser>(this.url + 'api/perfil/cambioclave', resetPasswordRepeat, this.httpOptionsJson);
  }

  setNewPassForgotten(resetPasswordRepeat: ResetPasswordForgotten): Observable<ReturnUser> {
    return this.http.post<ReturnUser>(this.url + 'api/usuarios/clave', resetPasswordRepeat, this.httpOptionsJson);
  }

  loginUser(loginUser: LoginUser): Observable<any> {

    let body = new URLSearchParams();
    body.set('username', loginUser.username);
    body.set('password', loginUser.password);

    return this.http.post<any>(this.url + 'login', body, this.httpOptions);
  }

  getNavbarOptions(): Observable<NavbarButton[]> {
    return this.http.get<NavbarButton[]>(this.url + 'api/navbar', this.httpOptions);
  }


  //  public verificoSesion() {
  //   if (!this.tokenDecoderService.isExpired()) {
  //     this.navegacion(JSON.parse(localStorage.getItem('user')), true);
  //   } else {
  //     this.logOut.limpiarStorage();
  //   }
  // }

  getUserData(): Observable<LoginData> {
    return this.http.get<LoginData>(this.url + 'api/perfil', this.httpOptions);
  }

  public handleUserData() {
    this.getUserData().subscribe(response => {
      const rol: string = response.rol;

      localStorage.setItem('idUsuario',response.idUsuario.toString());
      if(response.perfilAlumno) {
        localStorage.setItem('idAlumno',response.perfilAlumno.id.toString());
        if(response.perfilAlumno.estado) {
          const nombreCompleto: string = `${response.perfilAlumno.nombre} ${response.perfilAlumno.apellido} ${response.perfilAlumno.segundoApellido ? response.perfilAlumno.segundoApellido : ''}`;
          localStorage.setItem("descripcionUsuario",nombreCompleto);
          localStorage.setItem('estadoAlumno',response.perfilAlumno.estado);
        }
      } else {
        localStorage.setItem("descripcionUsuario",response.descripcionUsuario);
      }

      localStorage.setItem('rol',response.rol);

      if (rol === RoleString.ADMIN) {
        this.router.navigate(['/admin/alumnos']);
        this.snack.snackTranslate('snacks.sucess.login.admin');
      }
      if (response.claveDefecto) {
        // sessionStorage.setItem('id', response.idResetPass.toString());
        this.router.navigateByUrl("/change-password/");
      }

      if (rol === RoleString.STUDENT && response.perfilAlumno.estado === StatusEnum.CREATED && !response.claveDefecto) {
        this.router.navigate(['/welcome/']);
        this.snack.snackTranslate('snacks.sucess.login.user');
      }

      if (rol === RoleString.STUDENT && ( response.perfilAlumno.estado === StatusEnum.ACTIVADO  ) ) {
        // enviar mensaje cuando el alumno da feedback
        this.getDatosCanal(response.perfilAlumno.entrenador.id);
        this.router.navigate(['/planes/semana/']);
        this.snack.snackTranslate('snacks.sucess.login.user');
      }

      if (rol === RoleString.STUDENT &&  response.perfilAlumno.estado === StatusEnum.SUSPENDIDO  ) {
        this.router.navigate(['alumno/mi-perfil']);
        this.snack.snackTranslate('snacks.sucess.login.user');
      }

      if (rol === RoleString.STUDENT && response.perfilAlumno.estado === StatusEnum.PENDING) {
        this.router.navigate(['/thanks']);
        this.snack.snackTranslate('snacks.sucess.login.user');
      }
    }, error => {
      console.error(error);
      this.snack.snackTranslate('snacks.error.generic');
    });
  }

  /**
   * Save in localStorage canalId with the student's trainer.
   * @param entrenadorId 
   */
  getDatosCanal(entrenadorId: number) {
    this.parametrosService.getProcesos('EntrenadorUsuario',entrenadorId.toString()).subscribe( response=> {
      this.messagesService.getCanalUsuarioId(parseInt(response.valor,10)).subscribe(canal => {
        localStorage.setItem('canalIdEntrenador',canal.content[0].id.toString());
      },
        error => {
          console.error(error);
          this.snack.snackTranslate('snacks.error.generic');
        });
    },
    error => {
      console.error(error);
    });
  }


}
